import { desktopWormholeContract } from "@tastyworks/shared-domain-handoff/contracts/desktop-wormhole"
import { wormholeContract } from "@tastyworks/shared-domain-handoff/contracts/wormhole"
import { HandoffSender } from "@tastyworks/shared-domain-handoff/controller"
import { SingleResponse, type AdminTwLogin } from "@tastyworks/tastyworks-api"
import { isCookieAuthEnabled } from "../cookie-auth"
import { session } from "../tastyworks-rest"

const handoffToken = () => (isCookieAuthEnabled() ? null : session.sessionToken)

const handoffSender = new HandoffSender({
  contract: wormholeContract,
  source: "tradedesk",
  sessionToken: handoffToken,
})

const desktopHandoffSender = new HandoffSender({
  contract: desktopWormholeContract,
  source: "tradedesk",
  sessionToken: handoffToken,
  credentialParam: "tastyworksToken",
})

export const launchAccountBasedOnRegulatoryDomain = (accountNumber: string) => {
  launchDesktopApplication(getDesktopUrl(), accountNumber)
}

export const getWebBasedTwoUrl = () =>
  sessionStorage.getItem("isUserUsaRegulatoryDomain") === "true"
    ? import.meta.env.VITE_TT_WEB_BASE_URL
    : import.meta.env.VITE_IG_WEB_BASE_URL

export const getDesktopUrl = () =>
  sessionStorage.getItem("isUserUsaRegulatoryDomain") === "true"
    ? import.meta.env.VITE_TT_DESKTOP_PROTOCOL
    : import.meta.env.VITE_IG_DESKTOP_PROTOCOL

export const getElectronUrl = () => import.meta.env.VITE_TT_ELECTRON_PROTOCOL

export const initializeRegulatoryDomain = (
  response: SingleResponse<AdminTwLogin>
): void => {
  sessionStorage.setItem(
    "regulatoryDomains",
    response.data?.regulatoryDomain.join(",") ?? ""
  )
  sessionStorage.setItem(
    "isUserUsaRegulatoryDomain",
    (response.data?.regulatoryDomain.includes("USA") ?? false).toString()
  )
}

export const launchWebTwoPointOh = (env: string, accountNumber: string) => {
  window.open(
    handoffSender.buildUrl(new URL("login.html", env).toString(), {
      clientDomain: "employee",
      activeAccountNumber: accountNumber,
    }),
    "_blank"
  )
}

export const launchDesktopApplication = (
  env: string,
  accountNumber: string
) => {
  window.open(
    desktopHandoffSender.buildUrl(env, {
      activeAccountNumber: accountNumber,
    }),
    "_blank"
  )
}

export const launchElectronApp = (env: string, accountNumber: string) => {
  window.open(
    handoffSender.buildUrl(env, {
      clientDomain: "employee",
      activeAccountNumber: accountNumber,
    }),
    "_blank"
  )
}

export const APEX_CLEARING_BASE_URL =
  "https://public-apps.apexclearing.com/accounts/#"

export const launchApexClearing = (accountNumber: string) => {
  window.open(`${APEX_CLEARING_BASE_URL}/${accountNumber}`, "_blank")
}
